import { render, staticRenderFns } from "./qw.vue?vue&type=template&id=6c2b0bfa&scoped=true&"
import script from "./qw.vue?vue&type=script&lang=js&"
export * from "./qw.vue?vue&type=script&lang=js&"
import style0 from "./qw.vue?vue&type=style&index=0&id=6c2b0bfa&prod&lang=css&"
import style1 from "./qw.vue?vue&type=style&index=1&id=6c2b0bfa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b0bfa",
  null
  
)

export default component.exports